// extracted by mini-css-extract-plugin
module.exports = {"servicesContainer":"services_servicesContainer__T9G_K"};